import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { GlgTextInput } from 'Shared/components'

import useSessionStatusData from '../../hooks/useSessionStatusData'

import { selectTextSearch, setTextSearch } from '../../reducers/jobs_filters'

const formatTimeString = (isoDateString) => {
  if (!isoDateString) {
    return ''
  }

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(isoDateString))

}

const SessionStatusSearch = () => {
  const { currentSession } = useSessionStatusData()
  const dispatch = useDispatch()
  const textSearch = useSelector(selectTextSearch)

  const handleTextSearchChange = (value) => {
    dispatch(setTextSearch(value))
  }

  return ( <div className={'search-container'}>
    <div className={'search-info-container'}>
      <span className={'search-info-line'}>
        <span className={'search-info-text-bold'}>
          {window.I18n.t('clone_leagues_sessions.status_modal.created_by')}:
        </span>
        <span className={'search-info-text'}>{currentSession.created_by}</span>
      </span>
      <span className={'search-info-line'}>
        <span className={'search-info-text-bold'}>
          {window.I18n.t('clone_leagues_sessions.status_modal.date')}:
        </span>
        <span className={'search-info-text'}>{formatTimeString(currentSession?.created_at)}</span>
      </span>

    </div>

    <GlgTextInput
      onChange={handleTextSearchChange}
      value={textSearch}
      withAddon
    />
  </div>)
}

export default SessionStatusSearch
